import { render, staticRenderFns } from "./DocumentsResources.vue?vue&type=template&id=e506c27e"
import script from "./DocumentsResources.vue?vue&type=script&lang=js"
export * from "./DocumentsResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports